import { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";

import Select from "react-select";
import CampoDataDiviso from "components/inputFields/campoDataDiviso";

import entiFile from "const/enti.json";

import handleChangeGeneral from "apptools/handleChange";
import SelectComune from "components/inputFields/selectComune";

function DatiAnagraficiPublic(props) {
	const currentSede = import.meta.env.VITE_SEDE_ENTI;
	const { enti, distretti } = entiFile[currentSede];
	const makeObject = (array, field) => {
		if (!!array) {
			return array.reduce((acc, curr) => {
				let prop = curr[field];
				acc[prop] = curr;
				return acc;
			}, {});
		} else {
			return {};
		}
	};

	const entiObj = makeObject(enti, "value");
	const distrettiObj = distretti.reduce((acc, curr) => {
		acc[String(curr.CODICEENTE) + String(curr.CODICEDISTRETTO)] = curr;
		return acc;
	}, {});

	const [localitaNascita, setLocalitaNascita] = useState("");
	const [localitaDomicilio, setLocalitaDomicilio] = useState("");
	const [localitaResidenza, setLocalitaResidenza] = useState("");

	const [ente, setEnte] = useState(null);
	const [distretto, setDistretto] = useState(null);

	useEffect(() => {
		if (props.assistito) {
			if (!!props.assistito.RESIDENZALOCALITA) {
				setLocalitaDomicilio({
					id: 0,
					label: props.assistito.RESIDENZALOCALITA + "(" + props.assistito.RESIDENZAPROV + ")",
					comune: props.assistito.RESIDENZALOCALITA,
					provincia: props.assistito.RESIDENZAPROV,
				});
			}
			if (!!props.assistito.RESIDENZAVERALOCALITA) {
				setLocalitaResidenza({
					id: 0,
					label: props.assistito.RESIDENZAVERALOCALITA + "(" + props.assistito.RESIDENZAVERAPROV + ")",
					comune: props.assistito.RESIDENZAVERALOCALITA,
					provincia: props.assistito.RESIDENZAVERAPROV,
				});
			}

			if (props.assistito.NASCITALOCALITA) {
				setLocalitaNascita({
					id: 0,
					label: props.assistito.NASCITALOCALITA + "(" + props.assistito.NASCITAPROV + ")",
					comune: props.assistito.NASCITALOCALITA,
					provincia: props.assistito.NASCITAPROV,
				});
			}
			if (props.assistito.CODICEENTE) {
				setEnte(entiObj[props.assistito.CODICEENTE]);
				setDistretto(distrettiObj[props.assistito.CODICEENTE + props.assistito.CODICEDISTRETTO]);
			}
		}
	}, [props.assistito]);

	const handleChange = (event) => {
		handleChangeGeneral(event, props.setAssistito);
	};

	const handleChangeData = (date) => {
		props.setAssistito((prev) => {
			return { ...prev, NASCITADATA: date };
		});
	};

	const cambioResidenza = async (val) => {
		console.log(val, "" + val.codiceente + val.codicedistretto);
		if (!!!val) {
			setLocalitaResidenza("");
			props.setAssistito((prevAssistito) => {
				return {
					...prevAssistito,
					RESIDENZAVERALOCALITA: null,
					RESIDENZAVERAPROV: null,
					RESIDENZAVERACAP: null,
				};
			});
			return;
		}

		if (val.comune != props.assistito.RESIDENZAVERALOCALITA) {
			let dist = distrettiObj["" + val.codiceente + val.codicedistretto];

			let ass = {
				...props.assistito,
				RESIDENZAVERALOCALITA: val.comune,
				RESIDENZAVERAPROV: val.provincia,
				RESIDENZAVERACAP: val.cap,
			};

			if (!!dist) {
				props.setAssistito((prevAssistito) => {
					return {
						...prevAssistito,
						RESIDENZAVERALOCALITA: val.comune,
						RESIDENZAVERAPROV: val.provincia,
						RESIDENZAVERACAP: val.cap,
						CODICEENTE: prevAssistito.CODICEENTE,
						CODICEDISTRETTO: dist.CODICEDISTRETTO,
						MAILNOTIFICA: !!dist.EMAIL ? dist.EMAIL.split(",") : null,
						DISTRETTODESCRIZIONE: dist.DESCRIZIONE,
						DISTRETTOINDIRIZZO: dist.INDIRIZZO,
						DISTRETTOTELEFONO: dist.TELEFONO,
					};
				});
			} else {
				alert(
					"Attenzione la località indicata non fa parte degli enti ASL coperti dal servizio, indicare a quale ente far riferimento",
				);
				props.setAssistito(ass);
			}
		}
	};
	const cambioDomicilio = async (val) => {
		if (!val) {
			setLocalitaDomicilio("");
			props.setAssistito((prevAssistito) => {
				return {
					...prevAssistito,
					RESIDENZALOCALITA: null,
					RESIDENZAPROV: null,
					RESIDENZACAP: null,
				};
			});
		} else {
			props.setAssistito((prevAssistito) => {
				return {
					...prevAssistito,
					RESIDENZALOCALITA: val.comune,
					RESIDENZAPROV: val.provincia,
					RESIDENZACAP: val.cap,
				};
			});
		}
	};

	return (
		<>
			<Row>
				<Col xs={12}>
					<Form.Group>
						<Form.Label>E-mail per Ricevuta</Form.Label>

						<Form.Control
							type="text"
							name="EMAIL"
							required
							value={!!props.assistito.EMAIL ? props.assistito.EMAIL : ""}
							onChange={handleChange}
							maxLength="200"
							pattern="[a-zA-Z0-9@_\-\.]{1,200}"
						/>
						<Form.Control.Feedback type="invalid"> mail obbligatoria</Form.Control.Feedback>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col lg={5} xs={6}>
					<Form.Group>
						<Form.Label>Cognome</Form.Label>

						<Form.Control
							type="text"
							name="COGNOME"
							maxLength="30"
							pattern="[a-zA-Z\sÀÉÙÌÒÈòàùèéì']{1,30}"
							required
							value={props.assistito.COGNOME || ""}
							onChange={(val) => {
								val.target.value = val.target.value.toUpperCase();
								handleChange(val);
							}}
						/>
						<Form.Control.Feedback type="invalid">Campo obbligatorio. Solo lettere</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col lg={5} xs={6}>
					<Form.Group>
						<Form.Label>Nome</Form.Label>

						<Form.Control
							type="text"
							name="NOME"
							value={props.assistito.NOME || ""}
							maxLength="30"
							pattern="[a-zA-Z\sÀÉÙÌÒÈòàùèéì']{1,30}"
							required
							onChange={(val) => {
								val.target.value = val.target.value.toUpperCase();
								handleChange(val);
							}}
						/>
						<Form.Control.Feedback type="invalid">Campo obbligatorio. Solo lettere</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col lg={2} xs={6}>
					<Form.Group>
						<Form.Label>Sesso</Form.Label>
						<Form.Control
							as="select"
							type="select"
							name="SESSO"
							required
							value={props.assistito.SESSO ? props.assistito.SESSO.trim() : ""}
							onChange={handleChange}
						>
							<option value=""></option>
							<option value="M">M</option>
							<option value="F">F</option>
						</Form.Control>
						<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col xs={12} lg={4}>
					<Form.Label>Località Nascita</Form.Label>
					<Form.Control
						required
						value={localitaNascita ? localitaNascita : ""}
						hidden={true}
						onChange={() => {
							return;
						}}
					/>

					<SelectComune
						value={localitaNascita}
						placeholder="Località Nascita"
						onSelect={(val) => {
							if (val) {
								props.setAssistito((prevAssistito) => {
									return {
										...prevAssistito,
										NASCITALOCALITA: val.comune,
										NASCITAPROV: val.provincia,
									};
								});
							} else {
								setLocalitaNascita("");
								props.setAssistito((prevAssistito) => {
									return {
										...prevAssistito,
										NASCITALOCALITA: null,
										NASCITAPROV: null,
									};
								});
							}
						}}
					/>

					<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
				</Col>
				<Col xs={12} lg={4}>
					{/* <Form.Control type="date" dateformat="dd-mm-yyyy" name="NASCITADATA" required onChange={handleChange} value={props.assistito.NASCITADATA ? dataSigaoToNormal(props.assistito.NASCITADATA) : ""} disabled={visualizzazione || authCamp.NASCITADATA_D} />
                        <Form.Control.Feedback type="invalid">Campo obbligatorio, inserire prima anno poi data</Form.Control.Feedback> */}
					<CampoDataDiviso
						label="Data di nascita"
						value={props.assistito.NASCITADATA || ""}
						onChange={handleChangeData}
						name="NASCITADATA"
					/>
				</Col>
				<Col lg={4} xs={12}>
					<Form.Group>
						<Form.Label>Codice Fiscale</Form.Label>

						<Form.Control
							type="text"
							name="CODFISC"
							maxLength="16"
							pattern="[0-9A-Z_]{16,16}"
							required
							value={props.assistito.CODFISC || ""}
							onChange={(val) => {
								val.target.value = val.target.value.toUpperCase();
								handleChange(val);
							}}
						/>
						<Form.Control.Feedback type="invalid">Codice Errato</Form.Control.Feedback>
					</Form.Group>
				</Col>
			</Row>

			<Row>
				<Col xs={12} lg={6}>
					<Form.Group>
						<Form.Label>Località residenza</Form.Label>
						<Form.Control
							required
							value={localitaResidenza}
							hidden={true}
							onChange={() => {
								return;
							}}
						/>

						<SelectComune
							value={localitaResidenza}
							placeholder="Località Residenza"
							onSelect={cambioResidenza}
						/>
						<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col xs={9} lg={5}>
					<Form.Group>
						<Form.Label>Indirizzo residenza</Form.Label>
						<Form.Control
							type="text"
							name="RESIDENZAVERAINDIRIZZO"
							maxLength="50"
							pattern="[0-9a-zA-Z\s!\.,;:?!\/-èòàùìÀÉÙÌ'ÒÈ()+-_é]{0,50}"
							required
							value={props.assistito.RESIDENZAVERAINDIRIZZO || ""}
							onChange={handleChange}
						/>
						<Form.Control.Feedback type="invalid">
							Campo obbligatorio. solo numeri e lettere
						</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col lg={1} xs={3}>
					<Form.Group>
						<Form.Label>CAP</Form.Label>

						<Form.Control
							type="text"
							name="RESIDENZAVERACAP"
							maxLength="5"
							required
							pattern="[0-9]{5,5}"
							value={props.assistito.RESIDENZAVERACAP || ""}
							onChange={handleChange}
						/>
						<Form.Control.Feedback type="invalid">Inserire Cap Valido</Form.Control.Feedback>
					</Form.Group>
				</Col>
			</Row>
			<Row style={{ padding: "0.8rem 0rem" }}>
				<Col>
					<Form.Group>
						{/* <Form.Label> {"\u00A0"}</Form.Label> */}

						<Form.Check
							type="checkbox"
							style={{ height: "2rem", width: "2rem", marginRight: "20px" }}
							label={"Selezionare se il domicilio  è uguale alla residenza anagrafica (dove consegnare o ritirare gli ausili)".replace(
								/ /gi,
								"\u00A0",
							)}
							name="RESIDENZA"
							onChange={(val) => {
								if (val.target.checked) {
									setLocalitaDomicilio(localitaResidenza);
									props.setAssistito((prevAssistito) => {
										return {
											...prevAssistito,
											RESIDENZACAP: prevAssistito.RESIDENZAVERACAP,
											RESIDENZAINDIRIZZO: prevAssistito.RESIDENZAVERAINDIRIZZO,
											RESIDENZAPROV: prevAssistito.RESIDENZAVERAPROV,
											RESIDENZALOCALITA: prevAssistito.RESIDENZAVERALOCALITA,
										};
									});
								} else {
									setLocalitaDomicilio("");
									props.setAssistito((prevAssistito) => {
										return {
											...prevAssistito,
											RESIDENZACAP: null,
											RESIDENZAINDIRIZZO: null,
											RESIDENZAPROV: null,
											RESIDENZALOCALITA: null,
										};
									});
								}
								//  handleChange(val)
							}}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col xs={12} lg={6}>
					<Form.Group>
						<Form.Label>Località Domicilio</Form.Label>
						<Form.Control
							required
							value={localitaDomicilio}
							hidden={true}
							onChange={() => {
								return;
							}}
						/>

						<SelectComune
							value={localitaDomicilio}
							placeholder="Località Domicilio"
							onSelect={cambioDomicilio}
						/>
						<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col xs={9} lg={5}>
					<Form.Group>
						<Form.Label>Indirizzo Domicilio</Form.Label>
						<Form.Control
							type="text"
							name="RESIDENZAINDIRIZZO"
							maxLength="50"
							pattern="[0-9a-zA-Z\s!\.,;:?!\/-èòàùìÀÉÙÌ'ÒÈ()+-_é]{0,50}"
							required
							value={props.assistito.RESIDENZAINDIRIZZO || ""}
							onChange={handleChange}
						/>
						<Form.Control.Feedback type="invalid">
							Campo obbligatorio. solo numeri e lettere
						</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col lg={1} xs={3}>
					<Form.Group>
						<Form.Label>CAP</Form.Label>

						<Form.Control
							type="text"
							name="RESIDENZACAP"
							maxLength="5"
							required
							pattern="[0-9]{5,5}"
							value={props.assistito.RESIDENZACAP || ""}
							onChange={handleChange}
						/>
						<Form.Control.Feedback type="invalid">Inserire Cap Valido</Form.Control.Feedback>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col lg={5} xs={12}>
					<Form.Group>
						<Form.Label>Ente</Form.Label>
						<Form.Control
							required
							value={ente ? ente : ""}
							hidden={true}
							onChange={() => {
								return;
							}}
						/>
						<Select
							options={enti}
							isDisabled
							isSearchable
							onChange={(val) => {
								if (val) {
									props.setAssistito((prevAssistito) => {
										return { ...prevAssistito, CODICEENTE: val.value };
									});
								} else {
									setEnte(null);
									props.setAssistito((prevAssistito) => {
										return { ...prevAssistito, CODICEENTE: null };
									});
								}
							}}
							value={ente}
							placeholder="Ente"
						/>
						<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col lg={7} xs={12}>
					<Form.Group>
						<Form.Label>Distretto</Form.Label>
						<Form.Control
							required
							value={distretto ? distretto : ""}
							hidden={true}
							onChange={() => {
								return;
							}}
						/>
						<Select
							options={distretti.filter((k) => {
								if (ente) {
									return k.CODICEENTE == ente.value;
								} else return;
							})}
							isSearchable
							noOptionsMessage={() => {
								return <b>SELEZIONARE ENTE</b>;
							}}
							onChange={(val) => {
								if (val) {
									props.setAssistito((prevAssistito) => {
										return {
											...prevAssistito,
											CODICEDISTRETTO: val.value,
											MAILNOTIFICA: !!val.EMAIL ? val.EMAIL.split(",") : null,
											DISTRETTODESCRIZIONE: val.DESCRIZIONE,
											DISTRETTOINDIRIZZO: val.INDIRIZZO,
											DISTRETTOTELEFONO: val.TELEFONO,
										};
									});
								} else {
									setDistretto(null);
									props.setAssistito((prevAssistito) => {
										return { ...prevAssistito, CODICEDISTRETTO: null };
									});
								}
							}}
							value={distretto}
							placeholder="Distretto"
						/>
						<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
					</Form.Group>
				</Col>
			</Row>

			<Row>
				<Col lg={6} xs={6}>
					<Form.Group>
						<Form.Label>Telefono</Form.Label>

						<Form.Control
							type="text"
							name="TELEFONO"
							required
							pattern="[0-9]{1,27}"
							maxLength="27"
							value={props.assistito.TELEFONO || ""}
							onChange={handleChange}
						/>
						<Form.Control.Feedback type="invalid">
							campo obbligatorio. inserire solo numeri
						</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col lg={6} xs={6}>
					<Form.Group>
						<Form.Label>Cellulare</Form.Label>

						<Form.Control
							type="text"
							name="TELEFONO2"
							required
							pattern="[0-9]{1,27}"
							maxLength="27"
							value={props.assistito.TELEFONO2 || ""}
							onChange={handleChange}
						/>
						<Form.Control.Feedback type="invalid">
							campo obbligatorio. inserire solo numeri
						</Form.Control.Feedback>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col>
					<Form.Group className="mb-3">
						<Form.Label>Note Assistito</Form.Label>
						<Form.Control
							type="text"
							maxLength="6000"
							pattern="[0-9a-zA-Z\s!\.,;:?!\/-èòàùìÀÉÙÌ'ÒÈ()+-_é]{0,5950}"
							value={!!props.assistito.NOTE ? props.assistito.NOTE : ""}
							onChange={handleChange}
							name="NOTE"
						/>
						<Form.Control.Feedback type="invalid">
							massimo 6000 caratteri solo numeri e lettere
						</Form.Control.Feedback>
					</Form.Group>
				</Col>
			</Row>
		</>
	);
}

export default DatiAnagraficiPublic;
